<template>
    <div style="height: 100%">
        <template v-if="code=='RC01'">
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestCategoryName:''}}</span>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>

            <div  v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>
        </template>

        <template v-if="code=='RC02'">
            <!-- Темы обращения-->
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <div v-if="detailModel!=null&&detailModel.serviceTypeValues.length>0">
                    <span v-for="topic in detailModel.serviceTypeValues" class="text-request-details">
                        {{topic}}
                    </span>
                    <template  v-if="detailModel!=null&&detailModel.requestParam.length>0">
                        <span v-for="param in detailModel.requestParam">
                            <span v-if="param.requestParamType=='bool'&&param.paramValue==true" class="text-request-details">{{', '+param.paramName}}</span>
                        </span>
                    </template>
                </div>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>


            <div class="my-2" v-if="detailModel!=null">
                <div class="label-request-details">Местоположение</div>
                <a style="color:#0156AD; text-decoration-line: underline;" class="text-request-details">{{detailModel.latitude.toFixed(5)+', '+detailModel.longitude.toFixed(5)}}</a>
            </div>

            <div v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>

        </template>

        <template v-if="code=='RC03'">
            <div class="my-2">
                <div class="label-request-details">Тема обращения</div>
                <div v-if="detailModel!=null&&detailModel.serviceTypeValues.length>0">
                    <span v-for="(topic, index) in detailModel.serviceTypeValues" class="text-request-details">

                        {{(index>0?", ":'')+ topic}}
                    </span>
                    <template  v-if="detailModel!=null&&detailModel.requestParam.length>0">
                        <span v-for="param in detailModel.requestParam">
                            <span v-if="param.requestParamType=='bool'&&param.paramValue==true" class="text-request-details">{{', '+param.paramName}}</span>
                        </span>
                    </template>
                </div>
            </div>
            <div class="my-2">
                <div class="label-request-details">Описание проблемы</div>
                <span class="text-request-details">{{detailModel!=null?detailModel.requestText:''}}</span>
            </div>

            <div class="my-2" v-if="detailModel!=null">
                <div class="label-request-details">Местоположение</div>
                <a style="color:#0156AD; text-decoration-line: underline;" class="text-request-details">{{detailModel.latitude.toFixed(5)+', '+detailModel.longitude.toFixed(5)}}</a>
            </div>

            <div  v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc" class="label-request-details">Прикрепленные файлы</div>
            <attachments v-if="detailModel!=null&&detailModel.requestDoc.length>0" :items="detailModel.requestDoc"></attachments>

        </template>

    </div>
</template>

<script>
    /*
    * RC01 - Юридическая помощь
    * RC02 - Оценка ущерба
    * RC03 - Помощь автосервиса
    * */
    import API from '../../services/apiService.js'
    import attachments from '../Requests/DetailsRequestAttachments.vue'
    var api= new API();

    export default {
        props:["code", "requestId"],
        name: "OrderInfo",
        components:{attachments},
        data(){
            return {
                detailModel:null,
            }
        },
        mounted(){
            this.loadData();
        },
        methods:{
            loadData(){
                if(this.requestId!=null){
                    //заполняем детализацию в зависимости от категории
                    switch (this.code){
                        case "RC01":{
                            api.Get("RequestService/Request/LawyerRequest?requestId="+this.requestId).then((data)=>{
                                this.detailModel=data
                            }).catch(err=>{
                                console.log(err)
                            })
                            break;
                        }
                        case "RC02":{
                            api.Get("RequestService/Request/DamageRequest?requestId="+this.requestId).then((data)=>{
                                this.detailModel=data
                            }).catch(err=>{
                                console.log(err)
                            })
                            break;
                        }
                        case "RC03":{
                            api.Get("RequestService/Request/ServiceRequest?requestId="+this.requestId).then((data)=>{
                                this.detailModel=data
                            }).catch(err=>{
                                console.log(err)
                            })
                            break;
                        }
                        case "RC04":{
                            api.Get("RequestService/Request/InsuranceRequest?requestId="+this.requestId).then((data)=>{
                                this.detailModel=data
                            }).catch(err=>{
                                console.log(err)
                            })
                            break;
                        }

                    }

                }
            },
            isImage(url){
                var regStr= /\.jpg$/;
                return new RegExp(regStr, 'ig').test(url);
            },

        },
        watch:{
            requestId(val){
                this.detailModel=null
                this.loadData()
            }
        }
    }
</script>

<style scoped>
    .imageContainer{
        height: 96px;
        width: 96px;
        display: flex;
        align-items: center;
        overflow: hidden;
        border: 1px solid #D3DAE1;
    }
    .docFormat{
        margin: 0 auto 35px auto;
        font-size:30px;
        color:#ACB7C0;
        text-align: center;
    }
    .docName{
        padding: 2px;
        text-align: center;
        width: 94px; position: absolute; bottom:12px; left:13px; background-color: #D3DAE1;  color:#1A2A3A
    }
    .topicValue{
        margin-right: 5px;
        color: #3E6BAD;
        font-weight: 600;
        border-radius: 5px;
        padding: 3px 10px 3px 10px;
        border: 1px solid #0156AD;
    }
    .textRequest{
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        color: #1A2A3A;
    }

    .label-request-details {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: var(--color-2);
    }

    .text-request-details {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #1A2A3A;
    }
</style>